import React from 'react';

import { ResumeContentContext } from '../types';

/**
 * Determina la preposición de ubicación basada en si hay una dirección de inversión
 */
export const getLocationPreposition = (hasInvestmentAddress: boolean): 'in' | 'at' => {
  return hasInvestmentAddress ? 'at' : 'in';
};

/**
 * Crea un resumen para el equipo de procesamiento
 */
export const createProcessingTeamSummary = (
  context: ResumeContentContext,
  locationPreposition: 'in' | 'at'
) => {
  const { steps } = context;
  
  return (
    <React.Fragment>
      <div data-testid="onboarding-processing-team-summary">
        Show me {steps.loanType.element} loan terms for a {steps.propertyType.element}{' '}
        {steps.loanOwner.element} {locationPreposition} {steps.state.element}
      </div>
      <div data-testid="onboarding-processing-team-info">
        The borrower has a FICO score of {steps.ficoRange.element} and has purchased/sold {steps.propertiesNegotiated.element} in the past 36 months
      </div>
    </React.Fragment>
  );
};

